/* ============================================================
   mobile-nav.js
   Place in: Assets folder → name it "mobile-nav.js"
   ============================================================ */

(function () {
  var panel   = document.getElementById('mnavPanel');
  var overlay = document.getElementById('mnavOverlay');
  var activeSubId = null;

  /* Open the main nav panel */
  window.mnavOpen = function () {
    if (!panel) return;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  /* Close the main nav panel (also closes any open sub-menu) */
  window.mnavClose = function () {
    mnavCloseSub();
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  /* Open a specific sub-menu by its handle ID */
  window.mnavOpenSub = function (handleId) {
    var subEl = document.getElementById('mnav-sub-' + handleId);
    if (!subEl) return;

    /* Close any previously open sub-menu first */
    if (activeSubId) {
      var prev = document.getElementById('mnav-sub-' + activeSubId);
      if (prev) {
        prev.classList.remove('is-open');
        prev.setAttribute('aria-hidden', 'true');
      }
    }

    subEl.classList.add('is-open');
    subEl.setAttribute('aria-hidden', 'false');
    activeSubId = handleId;
  };

  /* Close the currently open sub-menu */
  window.mnavCloseSub = function () {
    if (!activeSubId) return;
    var subEl = document.getElementById('mnav-sub-' + activeSubId);
    if (subEl) {
      subEl.classList.remove('is-open');
      subEl.setAttribute('aria-hidden', 'true');
    }
    activeSubId = null;
  };

  /* Keyboard: Escape closes sub-menu first, then main panel */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (activeSubId) {
        mnavCloseSub();
      } else {
        mnavClose();
      }
    }
  });

  /* ── Intercept theme's native hamburger so it opens our nav ──
     Hooks into header-drawer's summary button using capture phase
     so it fires BEFORE the theme's own click handler            */
  document.addEventListener('DOMContentLoaded', function () {

    var selectors = [
      'header-drawer summary',
      'header-drawer .header__icon--menu',
      '.header__icon--menu',
      'details.menu-drawer-container > summary',
      '[aria-label="Menu"]'
    ];

    selectors.forEach(function (sel) {
      var btn = document.querySelector(sel);
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          mnavOpen();
        }, true); /* true = capture phase, fires before theme handler */
      }
    });

    /* Hide the theme's drawer panel so it can never appear */
    var drawerPanel = document.querySelector('.menu-drawer');
    if (drawerPanel) {
      drawerPanel.style.cssText = 'display:none!important';
    }

  });

})();
